const store = window.Shopify.shop;
let algoliaAPI = "0fe27b2f508a8cfa0e0ecb0a78049401";
let algoliaAppId = "O56IIFXCYC";
if (store.includes('dev')) {
  algoliaAPI = "b35b3fba81c148ac8133427f09017eda";
  algoliaAppId = "testingC56U7FKJ3I";
}
const debounce = (callback, wait) => {
    let timeoutId = null;
    return (...args) => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => {
        callback.apply(null, args);
        }, wait);
    };
}

function poll(fn, timeout, interval) {
  var endTime = Number(new Date()) + (timeout || 2000);
  interval = interval || 100;

  var checkCondition = function(resolve, reject) {
    var result = fn();
    if(result) {
      resolve(result);
    }
    else if (Number(new Date()) < endTime) {
      setTimeout(checkCondition, interval, resolve, reject);
    }
    else {
      // reject(new Error('timed out for ' + fn + ': ' + arguments));
      reject();
    }
  };

  return new Promise(checkCondition);
}

function uuidv4() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

document.addEventListener('click', e => {
  let target = e.target;
  while (target && !target.hasAttribute('data-product-url')) target = target.parentElement;
  target ? sessionStorage.setItem('scrollPosition', window.scrollY) : sessionStorage.removeItem('scrollPosition');
});
